export default function InfoTriangleIcon() {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M9.72992 3.99268C10.8219 2.39501 13.1787 2.39502 14.2707 3.99268L14.7026 4.62463C17.4086 8.58385 19.7336 12.7905 21.6463 17.1881L21.7365 17.3956C22.4106 18.9453 21.3922 20.705 19.7127 20.8927C14.587 21.4656 9.41353 21.4656 4.2879 20.8927C2.60836 20.705 1.58999 18.9453 2.26405 17.3956L2.35426 17.1881C4.26699 12.7905 6.59195 8.58384 9.298 4.62463L9.72992 3.99268ZM13.0003 9.00005C13.0003 9.55233 12.5526 10 12.0003 10C11.448 10 11.0003 9.55233 11.0003 9.00005C11.0003 8.44776 11.448 8.00005 12.0003 8.00005C12.5526 8.00005 13.0003 8.44776 13.0003 9.00005ZM12.0003 11.75C12.4145 11.75 12.7503 12.0858 12.7503 12.5V17.5C12.7503 17.9143 12.4145 18.25 12.0003 18.25C11.5861 18.25 11.2503 17.9143 11.2503 17.5V12.5C11.2503 12.0858 11.5861 11.75 12.0003 11.75Z"
                fill="currentColor"
            />
        </svg>
    )
}
